import type { CustomQuestion } from 'bookings-shared/lib/c2/services/schema/customQuestion';
import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('SET_CUSTOM_QUESTIONS', (questions: CustomQuestion[]) => {
    store.customQuestions = questions;
});
